// extracted by mini-css-extract-plugin
module.exports = {"container":"DocContent_container__2FCU1","default":"DocContent_default__3skxm"};